var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['square-button', _vm.widthClass]},[_c('b-button',{staticClass:"w-100",attrs:{"disabled":_vm.disabled},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('clicked')}}},[_c('img',{staticClass:"mr-2",attrs:{"src":_vm.icon,"alt":_vm.iconAlt}}),_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }